import Vue from 'vue'
const axios = require('axios')

export const openReminder = {
  methods: {
    async openReminder () {
      let ask = {
        uid: this.$userUid,
        action: 'waiting'
      }
      Vue.prototype.$lastClick = new Date()
      try {
        return axios
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/update-date-statistic', {ask})
      } catch (e) {
        return e
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/openReminder.js